import type { DeAddressVerificationResult } from '@ps/web-core-enums';
import { Site } from '@ps/web-core-enums';

import type { StatusCode } from '@swf/core/enums/statusCode';

import type { ErrorCollection } from './Response';

/* eslint-disable no-bitwise */
export enum UserPrivilege3 {
  MailListPoker = 1 << 0,
  MailListCasino = 1 << 1,
  MailListSports = 1 << 2,
  SportLiveAlert = 1 << 30,
  WithdrawalCancellation = 1 << 13,
  NoWithdraw = 1 << 7,
  NoSportsPlay = 1 << 4
}

export enum UserPrivilege2 {
  SuspendRM = 1 << (47 - 32),
  CannotSendTransfer = 1 << 3
}

export enum UserPrivilege {
  SelfExcluded = 1 << 26,
  PrivPlay = 1 << 0,
  PrivChat = 1 << 1
}

export enum UserFlag {
  RealMoneyOk = 1 << 3,
  AgeVerified = 1 << 12,
  AuthVerified = 1 << 20,
  RSARequired = 1 << 26,
  AccountPINRequired = 1 << 29
}

export enum UserFlag2 {
  ConvertBuyIn = 1 << 4,
  ConvertWinnings = 1 << 5,
  NoLoginEmailNotification = 1 << 8,
  BannedByRegulator = 1 << 28,
  AccountPINGenerated = 1 << 0,
  RSAActivated = 1 << 1,
  PendingFunds = 1 << 20,
  MobileVerified = 1 << 16
}

export enum UserFlag3 {
  OneTimePINRequired = 1 << 24,
  AMLVerified = 1 << (35 - 32),
  AMLDocsInProgress = 1 << (36 - 32),
  AMLSuspended = 1 << (37 - 32),
  AMLDepositThresholdReached = 1 << (38 - 32),
  AMLShowVerifiedModal = 1 << (40 - 32),
  KYCRequired = 1 << (46 - 32),
  VerifiedForMarketing = 1 << (47 - 32),
  VulnerablePlayer = 1 << (50 - 32),
  LicenseMobileVerified = 1 << 16
}

// TODO: EmailFlags should be merged with UserFlags above
export enum EmailFlag {
  Verified = 1 << 0,
  Bounced = 1 << 6,
  NotAuthorized = 1 << (51 - 32),
  AlwaysValidated = 1 << (50 - 32)
}

export interface EmailValidationFlags {
  verified: boolean;
  bounced: boolean;
  notAuthorized: boolean;
  alwaysValidated: boolean;
}

export interface Response {
  success: boolean;
  message?: string;
  errors?: ErrorCollection;
  statusCode?: StatusCode;
  messages?: { msg: { error: string } };
  deAddressVerificationResult?: DeAddressVerificationResult;
}

export interface AccountLocales {
  emLocale: number;
  emLocale2: number;
  emLocale3: number;
}
export interface AccountInfo {
  name?: string;
  addr1?: string;
  city?: string;
  zipCode?: string;
  state?: string;
  country?: string;
  countryCode?: string;
  phone?: string;
}

export const depositLimitExtendedSites = [
  Site.COM,
  Site.DE,
  Site.DESH,
  Site.DK,
  Site.ES,
  Site.EU,
  Site.GR,
  Site.NL,
  Site.PT,
  Site.RO,
  Site.SE,
  Site.UK,
  Site.USCO,
  Site.USMI,
  Site.USNJ,
  Site.USPA,
  Site.CAON
];

export enum UpdateAccountDetailsAction {
  Cancel,
  Confirm,
  Update
}
